import countTo from 'vue-count-to';
export default {
  components: {
    countTo
  },
  data() {
    return {
      autoplay: false,
      startVal: 0,
      yearsCount: 25,
      usersCount: 3,
      technologyCount: 30,
      apiUseCount: 100000000000
    };
  },
  methods: {
    handleScroll(bannerHeight, functionSectionHeight) {
      let scrollTop = document.documentElement.scrollTop || window.pageYOffset;
      if (!this.autoplay && scrollTop > bannerHeight + functionSectionHeight) {
        this.$refs.yearRef.start();
        this.$refs.userRef.start();
        this.$refs.technologyRef.start();
        this.$refs.apiRef.start();
        this.autoplay = true;
      }
    }
  },
  mounted() {
    // 处理滚动数字
    const banner = document.getElementsByClassName('openAI__banner-wrapper')[0];
    const functionSection = document.getElementsByClassName('openAI__function-wrapper')[0];
    const bannerHeight = banner.offsetHeight || banner.clientHeight;
    const functionSectionHeight = functionSection.offsetHeight || functionSection.clientHeight;
    window.addEventListener('scroll', () => {
      this.handleScroll(bannerHeight, functionSectionHeight);
    });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', () => {
      this.handleScroll();
    });
  }
};